import { render } from "./DaNang.vue?vue&type=template&id=39fb5bd0&scoped=true"
import script from "./DaNang.vue?vue&type=script&scoped=true&lang=js"
export * from "./DaNang.vue?vue&type=script&scoped=true&lang=js"

import "./DaNang.vue?vue&type=style&index=0&id=39fb5bd0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fb5bd0"]])

export default __exports__